package org.vreo.devicehub.features.device.presentation.addDevice

import org.vreo.devicehub.features.core.presentation.UiText

/**
 * Add device state
 */
data class AddDeviceState(
    val isLoading: Boolean = false,
    val error: UiText? = null,

    val invalidSerialNumber: Boolean = false,
    val invalidPassword: Boolean = false,

    val selectedProductIndex: Int = 0,
    val serialNumber: String = "",
    val tag: String = "",
    val linkingPassword: String = "",
)
